/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import moment from 'moment'
import { PropTypes } from 'prop-types'
import { withTranslation } from 'react-i18next'

import ProfileAvatar from '../../assets/images/mock/default-profile-icon.png'
import Op36Logo from '../../assets/images/logos/OP36_clean_icon_dark.png'

import './RoundsReportPrint.scss'

class RoundsReportPrint extends Component {
  render() {
    const { t } = this.props
    const user = this.props.user
    const community = user.communities[0]

    return (
      <div className='print-container m-5'>
        <div className='print-header-row'>
          <div>
            <div className='row py-4 d-flex align-items-center print-top-header'>
              <div className='d-flex flex-row align-items-center'>
                <div className='round-image-wrapper'>
                  <img
                    className='round-image'
                    src={user.avatar ? user.avatar.file_url : ProfileAvatar}
                    alt={`${user.first_name} ${user.last_name}`}
                  />
                </div>
                <div className='print-user-info-wrapper'>
                  <h3 className='print-name-text'>
                    {user.first_name} {user.last_name}
                  </h3>
                  {user.birthdate ? <div className='text-divider' /> : null}
                  <h5 className={'print-birthdate-text'}>
                    {user.birthdate ? this._getAge(user) : null}
                  </h5>
                </div>
              </div>
              <div>
                <p className='print-date-text'>
                  {moment().format('MM/DD/YYYY')}
                </p>
              </div>
            </div>
            <div className='row p-1  border-bottom'>
              <div className='col-2 d-flex flex-column justify-content-end'>
                <h6 className='text-center print-report-header'>{t('reports.common.level')}</h6>
              </div>
              <div className='col-2 d-flex flex-column justify-content-end'>
                <h6 className='text-center print-report-header'>{t('common.field.status')}</h6>
              </div>
              <div className='col-2 d-flex flex-column justify-content-end'>
                <h6 className='text-center print-report-header'>{t('reports.roundsReportPrint.attempts')}</h6>
              </div>
              <div className='col-2 d-flex flex-column justify-content-end'>
                <h6 className='text-center print-report-header'>{t('reports.roundsReportPrint.firstScore')}</h6>
              </div>
              <div className='col-2 d-flex flex-column justify-content-end'>
                <h6 className='text-center print-report-header'>{t('reports.roundsReportPrint.bestScore')}</h6>
              </div>
              <div className='col-2 d-flex flex-column justify-content-end'>
                <h6 className='text-center print-report-header'>
                  {t('common.golf.strokesLost')}
                </h6>
              </div>
            </div>
            {this._renderDivisions()}
          </div>
        </div>
        {/* <img
          src={DivisionCourse}
          alt='Level Course'
          className='print-division-course'
        /> */}
        <div className='row py-2 mt-5 d-flex align-items-center flex-row border-top border-bottom print-bottom-footer'>
          <div className='d-flex align-items-center flex-row'>
            <div className='small-round-image-wrapper'>
              <img
                className='round-image'
                src={
                  community?.photo
                    ? community.photo.file_url
                    : ProfileAvatar
                }
                alt={t('reports.roundsReportPrint.communityLogoAlt')}
              />
            </div>
            <p className='ml-2 mb-0 print-community-name'>
              {community.name}
            </p>
          </div>
          <div className='d-flex align-items-center flex-row print-op36-footer-wrapper'>
            <div className='small-round-image-wrapper'>
              <img
                className='round-image p-1'
                src={Op36Logo}
                alt={t('reports.roundsReportPrint.operation36LogoAlt')}
              />
            </div>
            <div className='print-footer-text-wrapper'>
              <p className='mb-0 print-op36-text'>{t('reports.roundsReportPrint.poweredByOperation36')}</p>
              <p className='mb-0 print-op36-copyright'>
                {t('reports.roundsReportPrint.copyright', { year: this._renderYear() })}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderYear = () => {
    const today = new Date()
    return today.getFullYear()
  }

  _renderDivisions = () => {
    const { t } = this.props
    return this.props.division.divisions.map((info) => (
      <div className='row p-0 border-bottom' key={info.division_id}>
        <div
          className={
            'col-2 p-0 d-flex flex-column justify-content-center text-white objective-rank-' +
          info.division_id +
          ' border-division-' +
          info.division_id
          }
        >
          <h6 className='text-center print-division-row-text'>
            {t('reports.roundsReportPrint.levelNumber', { level: info.division_id })}
          </h6>
          <p className='text-center mb-0 print-division-yardage'>
            {this._grabYardage(info.division_id)}
          </p>
        </div>
        <div className='col-2 py-3 d-flex justify-content-center align-items-center'>
          <div
            className='text-center mb-0'
            style={{
              color: this._renderStatusColor(
                info.nine_hole.division_attempts
                  ? info.nine_hole.division_attempts
                  : null,
                info.nine_hole.record_score
              ),
            }}
          >
            {info.nine_hole.record_score && info.nine_hole.record_score <= 36
              ? t('reports.roundsReportPrint.passed') + ' ' + String.fromCharCode(0x2713)
              : this._checkPace(info.nine_hole.division_attempts)}
          </div>
        </div>
        <div className='col-2 py-3 d-flex justify-content-center align-items-center'>
          <h1 className='text-center'>
            {info.nine_hole.division_attempts
              ? info.nine_hole.division_attempts
              : 0}
          </h1>
        </div>
        <div className='col-2 py-3 d-flex justify-content-center align-items-center flex-column'>
          <h5 className='text-center mb-0'>
            {info.nine_hole.first_score ? info.nine_hole.first_score : '---'}
          </h5>
        </div>
        <div className='col-2 py-3 d-flex justify-content-center align-items-center flex-column'>
          <h5 className='text-center mb-0'>
            {info.nine_hole.record_score
              ? info.nine_hole.record_score
              : '---'}
          </h5>
        </div>
        <div className='col-2 py-3 d-flex justify-content-center align-items-center'>
          <h1 className='text-center'>
            {info.nine_hole.record_score && info.nine_hole.first_score
              ? info.nine_hole.first_score - info.nine_hole.record_score
              : '---'}
          </h1>
        </div>
      </div>
    ))
  }

  _getAge = (user) => {
    const { t } = this.props
    const years = moment().diff(user.birthdate, 'years')

    return t('reports.roundsReportPrint.age', { years })
  }

  _checkPace = (attempts) => {
    const { t } = this.props
    if (!attempts) {
      return '---'
    } else if (attempts <= 20) {
      return t('reports.roundsReportPrint.aheadOfPace')
    } else {
      return t('reports.roundsReportPrint.onPace')
    }
  }

  _renderStatusColor = (attempts, bestScore) => {
    if (bestScore && bestScore <= 36) {
      return '#ff6633'
    }
    if (!attempts) {
      return 'black'
    }
    if (attempts >= 1 && attempts <= 20) {
      return '#33d9b2'
    } else if (attempts > 20) {
      return '#FFFF00'
    } else {
      return 'black'
    }
  }

  _grabYardage = (div) => {
    const { t } = this.props
    switch (div) {
      case 1:
        return t('reports.roundsReportPrint.yards', { yardage: 225 })
      case 2:
        return t('reports.roundsReportPrint.yards', { yardage: 450 })
      case 3:
        return t('reports.roundsReportPrint.yards', { yardage: 900 })
      case 4:
        return t('reports.roundsReportPrint.yards', { yardage: 1350 })
      case 5:
        return t('reports.roundsReportPrint.yards', { yardage: 1800 })
      case 6:
        return t('reports.roundsReportPrint.yardsRange', { from: 1801, to: 2300 })
      case 7:
        return t('reports.roundsReportPrint.yardsRange', { from: 2301, to: 2600 })
      case 8:
        return t('reports.roundsReportPrint.yardsRange', { from: 2601, to: 2900 })
      case 9:
        return t('reports.roundsReportPrint.yardsRange', { from: 2901, to: 3200 })
      case 10:
        return t('reports.roundsReportPrint.yardsPlus', { yardage: 3201 })
      default:
        return ''
    }
  }
}

RoundsReportPrint.propTypes = {
  division: PropTypes.shape({
    divisions: PropTypes.array,
  }),
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    birthdate: PropTypes.string,
    avatar: PropTypes.shape({
      file_url: PropTypes.string,
    }),
    communities: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      photo: PropTypes.shape({
        file_url: PropTypes.string,
      }),
    })),
  }),
}

export default withTranslation()(RoundsReportPrint)
